import axios from 'axios';
import { getBackendURL } from '@/util.js';

export default class PostService {
    constructor() {
        const baseURL = getBackendURL();
        this.urls = {
            getRecommendedPosts: `${baseURL}/v1/recommender/recommend`,
            createPost: `${baseURL}/v1/post/create`,
            fetchReplies: `${baseURL}/v1/post/child`
        }
    }

    async createPost(content) {
        let res = {
            data: null,
            error: null
        }
        try {
            const response = await axios.post(
                this.urls.createPost,
                {
                    content: content,
                },
                {
                    withCredentials: true
                }
            );
            res.data = response.data;
        } catch (error) {
            res.error = error;
        }
        return res;
    }

    async getRecommendedPosts(offset, limit) {
        let url = `${this.urls.getRecommendedPosts}?offset=${offset}&limit=${limit}`;
        let res = {
            data: null,
            error: null
        }
        try {
            const response = await axios.get(url, {
                withCredentials: true
            });
            res.data = response.data;
            if (res.data === null) {
                res.data = [];
            }
        } catch (error) {
            res.error = error;
        }
        return res;
    }

    async fetchReplies(postID, offset, limit) {
        let res = {
            data: null,
            error: null
        }
        try {
            let url = `${this.urls.fetchReplies}/${postID}?offset=${offset}&limit=${limit}`;
            const response = await axios.get(url, {
                withCredentials: true
            });
            res.data = response.data;
            if (res.data === null) {
                res.data = [];
            }
        } catch (error) {
            res.error = error;
        }
        return res;
    }
}
